import { GlobalContext, Section } from "../lib/Root";
import { useContext, useEffect } from "react";

export default function AccountSettings() {
	var _ = useContext(GlobalContext);
	useEffect(() => { _.document.title = "Settings"; }, []);

	return <Section center>
		<p>You think we offer settings?</p>
	</Section>;
}